import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Note } from 'app/core/models/note.model';
import { NotesService } from 'app/core/services/notes.service';

import { NoteComponent } from '../note/note.component';
import { NotesForModelAddComponent } from '../notes-for-model-add/notes-for-model-add.component';
import { BlankValueDashComponent } from '../blank-value-dash/blank-value-dash.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-notes-for-model',
    templateUrl: './notes-for-model.component.html',
    styleUrls: ['./notes-for-model.component.scss'],
    imports: [NoteComponent, NotesForModelAddComponent, BlankValueDashComponent, MatProgressSpinner]
})
export class NotesForModelComponent implements OnInit {
  private notesService = inject(NotesService);

  @Input() model: any;
  @Input() modelType: string;
  @Input() minimizeControls = false;
  @Input() allowAdd = true;
  @Input() noNotesMessage = "There are currently no notes.";

  @Output() noteAdded = new EventEmitter<Note>();

  notes: Note[] = [];
  loading = true;

  ngOnInit() {
    this.init();
  }

  onNoteAdded(note: Note) {
    this.notes.unshift(note);
    this.noteAdded.emit(note);
  }

  private init() {
    if (this.model.notes !== undefined) {
      this.notes = this.model.notes;
      this.loading = false;
    } else {
      this.loadNotes();
    }
  }

  private loadNotes() {
    this.loading = true;

    this.notesService.getForModel(this.model.id, this.modelType).subscribe((notes: Note[]) => {
      this.notes = notes;
      this.loading = false;
    });
  }
}
